import { ChangeEvent, useRef, useState, useEffect } from "react";
import { CheckCircleIcon, PencilIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { useFormContext } from "react-hook-form";

export const TestName = () => {
  const { setValue, watch } = useFormContext();
  const [isTestNameEditEnabled, setTestNameEditEnabled] = useState(false);
  const testNameInputRef = useRef<HTMLInputElement>(null);

  const testNameWatch = watch("TestName");
  const [testName, setTestName] = useState(testNameWatch);

  const handleChangeName = (e: ChangeEvent<HTMLInputElement>) => {
    setTestName(e.target.value);
  };

  const editTestName = () => {
    setTestNameEditEnabled(true);
  };

  const cancelEditTestName = () => {
    setTestName(testNameWatch);
    setTestNameEditEnabled(false);
  };

  const saveNewTestName = () => {
    setValue("TestName", testName);
    setTestNameEditEnabled(false);
  };

  useEffect(() => {
    if (isTestNameEditEnabled && testNameInputRef.current) {
      testNameInputRef.current.focus();
    }
  }, [isTestNameEditEnabled]);

  return (
    <div className="flex justify-between">
      {isTestNameEditEnabled ? (
        <div className="flex justify-between w-full mb-5">
          <input
            ref={testNameInputRef}
            type="text"
            value={testName}
            onChange={handleChangeName}
            className="w-full text-[30px] leading-[38px] font-bold text-black p-0 border-0 focus:outline-none focus:ring-2 focus:ring-gray-400"
          />
          <div className="flex justify-between">
            <button onClick={saveNewTestName}>
              <CheckCircleIcon height="24" width="24" />
            </button>
            <button onClick={cancelEditTestName}>
              <XMarkIcon height="24" width="24" />
            </button>
          </div>
        </div>
      ) : (
        <div className="flex justify-between w-full">
          <h1 className="text-black mb-5">{testNameWatch}</h1>

          <button onClick={editTestName}>
            <PencilIcon height="20" width="20" />
          </button>
        </div>
      )}
    </div>
  );
};
